import React, { useRef } from "react";
import { Image } from "antd";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import classNames from "classnames";

// interfaces
import { ISearchMapMarkCarousel } from "../ISearchMapMark";

// assets
import "swiper/css";
import "swiper/css/pagination";
import styles from "@/assets/styles/components/search-map-mark-carousel.module.scss";


function SearchMapMarkCarousel(props: ISearchMapMarkCarousel) {
  const {
    items,
    className,
    imageStyle = {},
    children,
    loop = true,
    ...rest
  } = props;

  const swiperRef = useRef<SwiperCore | null>(null);


  return (<>
    <Swiper
      slidesPerView={1}
      spaceBetween={12}
      modules={[Pagination]}
      pagination={{ clickable: true, }}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper;
      }}
      loop={loop}
      className={classNames(styles["locl-search-map-mark-carousel"], className)}
      { ...rest }
    >
      {children}
      {items.length > 1 && (
        <div
          onClick={() => swiperRef.current?.slidePrev()}
          data-testid="locl-search-map-mark-carousel-prev"
          className={classNames(styles["locl-search-map-mark-carousel__navigation"], styles["locl-search-map-mark-carousel__navigation_left"])}
        >
          <FaChevronLeft/>
        </div>
      )}
      {
        (items || []).map((item, index) => (
          <SwiperSlide
            key={`LocationSpaceCarousel-${index}`}
            className={styles["locl-search-map-mark-carousel__slide"]}
          >
            <Image
              width="100%"
              height="100%"
              loading="lazy"
              src={item.src}
              alt={item.alt}
              className={styles["locl-search-map-mark-carousel__slide-image"]}
              style={imageStyle}
              preview={false}
            />
          </SwiperSlide>
        ))
      }
      {items.length > 1 && (
        <div
          onClick={() => swiperRef.current?.slideNext()}
          className={classNames(styles["locl-search-map-mark-carousel__navigation"], styles["locl-search-map-mark-carousel__navigation_right"])}
          data-testid="locl-search-map-mark-carousel-next"
        >
          <FaChevronRight/>
        </div>
      )}
    </Swiper>
  </>);
}

export default SearchMapMarkCarousel;
